import { atomWithStorage } from "jotai/utils";
import {
  COLLAPSE_MENU,
  DARK_MODE,
  ERROR_CONTENT,
  ERROR_TITLE,
  GET_DIALOG_DATA,
  GET_DIALOG_STATUS,
  GET_SESSION_ID_STATUS,
  GET_SUCCESS_DIALOG_STATUS,
  GLOBAL_SEARCH,
  INITIATE_FILE_DOWNLOAD,
  IS_AUTH_PAGE,
  OPEN_SLIDING_MENU,
  PROGRESS_STATUS,
  SELECTED_BATCH_NUMBER,
  SELECTED_TAB,
} from "../constants/Constant";
import { ALERT } from "../constants/Strings";

export const darkModeAtom = atomWithStorage(DARK_MODE, false);

export const openSlidingMenu = atomWithStorage(OPEN_SLIDING_MENU, true);
export const showErrorAlertDialog = atomWithStorage(GET_DIALOG_STATUS, false);
export const showSuccessAlertDialog = atomWithStorage(GET_SUCCESS_DIALOG_STATUS, false);

export const selectedBatchNo = atomWithStorage(SELECTED_BATCH_NUMBER, "");
export const sessionIdStatus = atomWithStorage(GET_SESSION_ID_STATUS, "");
export const isAuthPageAtom = atomWithStorage(IS_AUTH_PAGE, true);
export const collapseMenu = atomWithStorage(COLLAPSE_MENU, true);
export const globalSearchText = atomWithStorage(GLOBAL_SEARCH, "");
export const selectedItems = atomWithStorage(GET_DIALOG_DATA, {});
export const selectedSidebarTab = atomWithStorage(SELECTED_TAB, "Dashboard");

//Api and network error message
export const loadingStatus = atomWithStorage(PROGRESS_STATUS, true);
export const alertBoxTitle = atomWithStorage(ERROR_TITLE, ALERT);
export const alertBoxContent = atomWithStorage(ERROR_CONTENT, "");
export const dialogStatus = atomWithStorage(GET_DIALOG_STATUS, false);
export const triggerFileDownload = atomWithStorage(INITIATE_FILE_DOWNLOAD, false);
